import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { MsalModule, MSAL_INSTANCE } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { NgIdleModule } from '@ng-idle/core';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
 
const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.clientId,
    authority: 'https://login.microsoftonline.com/' + environment.tenantid,
    redirectUri: environment.redirectUri,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),

    { provide: MSAL_INSTANCE, useValue: msalInstance },

    importProvidersFrom(
      NgIdleModule.forRoot(),
      MsalModule.forRoot(
        msalInstance,
        {
          interactionType: InteractionType.Popup,
          authRequest: {
            scopes: ['user.read'],
            prompt: 'login'
          }
        },
        {
          interactionType: InteractionType.Popup,
          protectedResourceMap: new Map([
            ['https://graph.microsoft.com/v1.0/me', ['user.read']]
          ])
        }
      )
    )
  ]
};
